import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  // {
  // path: "/about",
  // name: "About",
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  // component: () =>
  //   import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },

  {
    path: "/Deberes-y-Derechos",
    name: "Deberes-y-Derechos",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Deberesyderechos.vue"),
  },
  {
    path: "/Acerca-De-Nosotros",
    name: "Acerca-De-Nosotros",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AcercadeNosotros.vue"),
  },
  {
    path: "/Programa-Angel-Familia",
    name: "Programa-Angel-Familia",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Programas/AngelFamilia.vue"
      ),
  },
  {
    path: "/Programa-Plan-Canguro",
    name: "Programa-Plan-Canguro",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Programas/PlanCanguro.vue"
      ),
  },

  {
    path: "/Copasst",
    name: "Copasst",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Copasst.vue"),
  },
  {
    path: "/SARLAFT-FPADM",
    name: "SARLAFT-FPADM",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/SarlaftFpadm.vue"),
  },
  {
    path: "/Denuncias-Transparencia",
    name: "Denuncias-Transparencia",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/DenunciaForm.vue"),
  },

  {
    path: "/Sistema-Unico-de-Habilitacion",
    name: "Sistema-Unico-de-Habilitacion",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/SistemaHabilitacion.vue"
      ),
  },

  {
    path: "/Noticias",
    name: "Noticias",
    component: () => import("../views/Noticias.vue"),
  },
  {
    path: "/Noticias/Noticia1",
    name: "Noticia1",
    component: () => import("../components/enlaregion/Noticia1.vue"),
  },
  {
    path: "/Noticias/Noticia2",
    name: "Noticia2",
    component: () => import("../components/enlaregion/Noticia2.vue"),
  },
  {
    path: "/Noticias/Noticia3",
    name: "Noticia3",
    component: () => import("../components/enlaregion/Noticia3.vue"),
  },

  {
    path: "/Politica-de-Tratamiento-de-la-Informacion",
    name: "Politica-de-Tratamiento-de-la-Informacion",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/PoliticaDeTratamiento.vue"
      ),
  },
  {
    path: "/Asociacion-De-Usuarios",
    name: "Asociacion-De-Usuarios",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AsociacionUsuarios.vue"),
  },

  /*FORMULARIOS */
  {
    path: "/Contactenos",
    name: "Contactenos",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contacto.vue"),
  },
  {
    path: "/PQR",
    name: "Pqr",
    component: () => import(/* webpackChunkName: "about" */ "../views/Pqr.vue"),
  },
  {
    path: "/Citas-En-Linea",
    name: "Citas-En-Linea",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CitasEnLinea.vue"),
  },
  {
    path: "/Trabaja-Con-Nosotros",
    name: "Trabaja-Con-Nosotros",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Trabajaconnosotros.vue"),
  },
  // RUTAS PLANES
  {
    path: "/PlanPlus",
    name: "PlanPlus",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Planes/PlanPlus.vue"),
  },
  {
    path: "/PlanElite",
    name: "PlanElite",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Planes/PlanElite.vue"),
  },
  {
    path: "/PlanGold",
    name: "PlanGold",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Planes/PlanGold.vue"),
  },
  // {
  //   path:"/Planes/:plan",
  //   name:"Planes",
  //   component: () =>
  //   import(/* webpackChunkName: "about" */ "../views/DetallesPlanes.vue"),
  // },
  {
    path: "/Sedes",
    name: "Sedes",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Sedes.vue"),
  },
  {
    path: "/Estados-Financieros",
    name: "EstadosFinancieros",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/EstadosFinancieros.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/NotFound.vue"),
  },
  {
    path: "/Estados-Financieros-2019",
    name: "EstadosFinancieros-2019",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/EstadosFinancieros/EF2019.vue"
      ),
  },
  {
    path: "/Servicios",
    name: "Servicios",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Servicios.vue"),
  },
  {
    path: "/Servicio-de-Cirugia",
    name: "Servicio-de-Cirugia",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Servicios/Cirugia.vue"),
  },
  {
    path: "/Unidad-de-Cirugia-Cardio-Vascular",
    name: "Unidad-de-Cirugia-Cardio-Vascular",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/CardioVascular.vue"
      ),
  },
  {
    path: "/Hospitalizacion-General",
    name: "Hospitalizacion-General",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/HospitalizacionGeneral.vue"
      ),
  },
  {
    path: "/Hospitalizacion-Ginecologica-Y-Obstetricia-Sala-De-Partos",
    name: "Hospitalizacion-Ginecologica-Y-Obstetricia-Sala-De-Partos",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/HospitalizacionGinecologica.vue"
      ),
  },
  {
    path: "/Laboratorio-Clinico-De-Alta-Complejidad",
    name: "Laboratorio-Clinico-De-Alta-Complejidad",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/LaboratorioClinico.vue"
      ),
  },
  {
    path: "/Unidad-De-Cuidados-Intensivos",
    name: "Unidad-De-Cuidados-Intensivos",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/UnidadAdultos.vue"
      ),
  },
  {
    path: "/Unidad-De-Cuidados-Intensivos-Neonatal",
    name: "Unidad-De-Cuidados-Intensivos-Neonatal",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/UnidadNeonatal.vue"
      ),
  },
  {
    path: "/Unidad-De-Cuidados-Intensivos-Pediatricos",
    name: "Unidad-De-Cuidados-Intensivos-Pediatricos",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/UnidadPediatricos.vue"
      ),
  },
  {
    path: "/Servicio-De-Urgencias",
    name: "Servicio-De-Urgencias",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/ServicioUrgencias.vue"
      ),
  },
  {
    path: "/Servicio-De-Urgencias-VIP",
    name: "Servicio-De-Urgencias-VIP",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/UrgenciasVIP.vue"
      ),
  },
  {
    path: "/Servicio-De-Imagenologia",
    name: "Servicio-De-Imagenologia",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/Imagenologia.vue"
      ),
  },
  {
    path: "/Ecografia-Convecional",
    name: "Ecografia-Convecional",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/EcografiaConvencional.vue"
      ),
  },
  {
    path: "/Ecografia-Obstetricas",
    name: "Ecografia-Obstetricas",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/EcografiaObstetricas.vue"
      ),
  },
  {
    path: "/Rayos-X",
    name: "Rayos-X",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Servicios/RayosX.vue"),
  },
  {
    path: "/Tomografia-Axial-Computarizada",
    name: "Tomografia-Axial-Computarizada",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/TomografiaAxial.vue"
      ),
  },
  {
    path: "/Resonancia-Magnetica",
    name: "Resonancia-Magnetica",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/ResonanciaMagnetica.vue"
      ),
  },
  {
    path: "/Unidad-de-Hemodinamia",
    name: "Unidad-de-Hemodinamia",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/UnidadHemodinamia.vue"
      ),
  },
  {
    path: "/Servicio-de-consulta-externa",
    name: "Servicio-de-consulta-externa",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/ConsultaExterna.vue"
      ),
  },
  {
    path: "/Servicio-de-farmaceutica-hospitalaria",
    name: "Servicio-de-farmaceutica-hospitalaria",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/FarmaciaHospitalaria.vue"
      ),
  },
  {
    path: "/Servicio-de-ayudas-diagnosticas-y-compplementacion-terapeutica",
    name: "Servicio-de-ayudas-diagnosticas-y-compplementacion-terapeutica",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Servicios/AyudasDiagnosticas.vue"
      ),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach(async (to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export default router;
